export default "/images/mouseIcon.png?e6ce920a5731cc9b4da1e66d3de6aeeb";